module.exports = __webpack_public_path__ + "static/media/work_asthma.895dbfac.png";